window.Products.DeviceCase.Iphone6Plus = function() {
};
window.Products.DeviceCase.Iphone6Plus.inherits(window.Products.DeviceCase.DeviceCase);
window.Products.DeviceCase.Iphone6Plus.id = 54;
window.Products.DeviceCase.Iphone6Plus.slug = 'iphone6plus';